import { render, staticRenderFns } from "./group-add.vue?vue&type=template&id=b6dee236&"
import script from "./group-add.vue?vue&type=script&lang=js&"
export * from "./group-add.vue?vue&type=script&lang=js&"
import style0 from "./group-add.vue?vue&type=style&index=0&id=b6dee236&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports